import React from 'react'
import { useDispatch } from 'react-redux';
import { addAllsales, addCustomer, addExpense, addsale ,addTotalExpense,addTotalSale} from 'Redux/Reducer/SaleSlice';
import AxiosService from 'utils/AxiosService';

function UseSale() {

    const dispatch = useDispatch();
    const getAllSale = async() => {
        try {
            let res =await AxiosService.get("/vendor/getVendorSales");
            // console.log(res.data)
            if(res.status == 200){
                dispatch(addAllsales(res?.data?.sales));
                dispatch(addTotalSale(res?.data?.totalSales));
            }
        } catch (error) {
            console.log(error);
        }
    }
    const getAllSaleByAdmin = async() => {
        try {
            let res =await AxiosService.get("/admin/sales");
            // console.log(res.data)
            if(res.status == 200){
                dispatch(addAllsales(res?.data?.sales));
                dispatch(addTotalSale(res?.data?.totalAmount));
            }
        } catch (error) {
            console.log(error);
        }
    }   
    const getAllExpenseByVendor = async() => {
        try {
            let res =await AxiosService.get("/vendor/getVendorExpenses");
            // console.log(res.data)
            if(res.status == 200){
                dispatch(addExpense(res?.data?.expenses));
                dispatch(addTotalExpense(res?.data?.totalExpenses));
            }
        } catch (error) {
            console.log(error);
        }
    }
    const getAllCustomerByVendor = async() => {
        try {
            let res =await AxiosService.get("/vendor/getVendorCustomers");
            // console.log(res.data)
            if(res.status == 200){
                dispatch(addCustomer(res?.data?.data));
                // dispatch(addExpense(res?.data?.expenses));
                // dispatch(addTotalExpense(res?.data?.totalExpenses));
            }
        } catch (error) {
            console.log(error);
        }
    }
  return {getAllSale,getAllSaleByAdmin,getAllExpenseByVendor,getAllCustomerByVendor}
}

export default UseSale